import axios from 'axios'

const API_BASE_URL = import.meta.env.VITE_API_URL || 'http://localhost:3000'

// Create axios instance with base configuration
const apiClient = axios.create({
  baseURL: API_BASE_URL,
  timeout: 10000,
  headers: {
    'Content-Type': 'application/json'
  }
})

// Response interceptor for error handling
apiClient.interceptors.response.use(
  response => response,
  error => {
    console.error('API Error:', error)
    throw error
  }
)

export const apiService = {
  // Check API health
  async getHealth() {
    const response = await apiClient.get('/health')
    return response.data
  },

  // Get stored data
  async getData(limit = 100) {
    const response = await apiClient.get('/api/data', {
      params: { limit }
    })
    return response.data
  }
}

export default apiService 